import { ca } from '@cian/analytics';

import { getSiteType } from '../../utils/getSiteType';
import { TDeviceType } from '@cian/ui-kit';
import { EPageTypes } from '../../constants/page';

export interface ITrackClickNextData {
  deviceType: TDeviceType;
  queryString: string;
  category: EPageTypes;
  address?: string;
  area?: number;
  roomsCount?: number;
  houseArea?: number;
  landArea?: number;
}

export function trackClickNext(params: ITrackClickNextData) {
  const { deviceType, queryString, address, area, roomsCount, category, houseArea, landArea } = params;

  ca('eventSite', {
    name: 'oldevent',
    category,
    action: 'Click',
    label: 'Calculate',
    page: {
      pageType: category,
      siteType: getSiteType(deviceType),
      queryString,
      extra: {
        address: address || undefined,
        area: area || undefined,
        roomsCount: roomsCount || undefined,
        houseArea: houseArea || undefined,
        landArea: landArea || undefined,
      },
    },
  });
}
